"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.UploadAppPackageFailedError = void 0;
const teamsfx_api_1 = require("@microsoft/teamsfx-api");
const localizeUtils_1 = require("../../../../../common/localizeUtils");
const constants_1 = require("../utility/constants");
const errorCode = "UploadAppPackageFailed";
const messageKey = "plugins.spfx.uploadAppcatalogFail";
class UploadAppPackageFailedError extends teamsfx_api_1.SystemError {
    constructor(error) {
        super({
            source: constants_1.Constants.DeployDriverName,
            name: errorCode,
            message: localizeUtils_1.getDefaultString(messageKey, error.message),
            displayMessage: localizeUtils_1.getLocalizedString(messageKey, error.message),
        });
    }
}
exports.UploadAppPackageFailedError = UploadAppPackageFailedError;
//# sourceMappingURL=uploadAppPackageFailedError.js.map